import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs } from 'js/components/design-system';
import { csqEntryBreadcrumbsHistory } from './functions';

const CSQEntryBreadcrumbs = () => {
  const location = useLocation();
  const { t } = useTranslation();
  return (
    <Breadcrumbs
      className="csq-entry-breadcrumbs"
      history={csqEntryBreadcrumbsHistory(t, location)}
    />
  );
};

export default CSQEntryBreadcrumbs;
